import React from 'react'
import { LogVaultTable, ColorCircularProgress } from 'components'
import { useSelector } from 'react-redux'

const VaultLog = () => <LogVaultTable />

export default VaultLog
